// OpenUI Lang component-library CSS — must load on the client (same import
// the real app does in app/labs/genui/client.tsx / apps/spa-probe's main.tsx).
import '@openuidev/react-ui/components.css';
import '@/app/labs/genui/openui-overrides.css';
import './index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { routeTree } from './route-tree';
import { meOnce } from './lib/auth';
import { registerChatRouter } from './next-compat/chat-url';

// Router context populated ONCE at boot (FRONTEND_SPA_DESIGN.md §3b). See
// lib/auth.ts's TODO for the Clerk signIn/signOut re-fetch + invalidate
// wiring this scaffold intentionally leaves for the G1 batch.
const router = createRouter({
  routeTree,
  context: { me: meOnce() },
  defaultPreload: 'intent',
});

// The chat view swaps the URL onto the session it mints mid-turn; that swap must
// go through the ROUTER (a tagged replace) instead of a raw history.replaceState,
// or TanStack re-matches and unmounts the streaming chat. The shim reaches the
// router by registration rather than by import — importing it would be a cycle
// (router → routeTree → chat view → shim). See next-compat/chat-url.ts.
registerChatRouter(router);

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
